<template>
  <div class="ag-page_users position-relative">
    <ag-card :module="module"></ag-card>
    <div
      class="modal fade ag-modal ag-otp-modal"
      id="resetPassModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="ag-modal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3>{{$t("newPassword")}}</h3>
          </div>

          <div class="result">
            <div class="modal-body">
              <div
                class="d-flex align-items-center flex-column"
                v-if="!passLoading && resetPassStep == 2"
              >
                <h4 class="mr-2">
                  {{$t("TheNewPassword")}} :
                  <strong
                    style="
                      padding: 6px;
                      background: #eae9e9;
                      border-radius: 6px;
                    "
                    >{{ passResult }}</strong
                  >
                </h4>
                <br />
                <button
                  type="button"
                  @click="copy"
                  class="border-0 ag-button ag-button_radius pr-4 pl-4 ag-button_secondary"
                >
                  {{$t("copy")}}
                </button>
              </div>
              <div
                class="d-flex align-items-center flex-column"
                v-if="!passLoading && resetPassStep == 1 && selectedUser"
              >
                <h4 class="mr-2">
                  Reset Password for the user
                  <strong>{{
                    `${selectedUser.firstName} ${selectedUser.lastName}`
                  }}</strong>
                </h4>
                <br />
                <button
                  type="button"
                  @click="resetPassSubmit"
                  class="border-0 ag-button ag-button_radius pr-4 pl-4 ag-button_secondary"
                >
                  Reset Now
                </button>
              </div>
              <ag-loading v-if="passLoading" />
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="border-0 ag-button ag-button_radius pr-4 pl-4 ag-button_primary float-inline-end"
                data-dismiss="modal"
              >
                {{$t("close")}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade ag-modal ag-otp-modal"
      id="assignedResourceModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="ag-modal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3>Assigned Resources</h3>
          </div>

          <div class="result">
            <div class="modal-body">
              <div
                class="d-flex align-items-center flex-column w-50"
                v-if="!userAssetLoading && userAsset"
              >
                <div class="row w-100">
                  <div class="col-md-12 text-center">
                    <h4 v-if="userAsset.role === Roles.SiteAdmin">
                      {{ userAsset.siteCount == 1 ? "Site" : "Sites" }}
                    </h4>
                    <h4 v-if="userAsset.role === Roles.GroupAdmin">
                      {{ userAsset.groupCount == 1 ? "Group" : "Groups" }}
                    </h4>
                    <h4 v-if="userAsset.role === Roles.CompanyAdmin">
                      {{
                        userAsset.companyCount == 1
                          ? "Company"
                          : "Companies"
                      }}
                    </h4>
                    <h4 v-if="userAsset.role === Roles.PartnerAdmin">
                      Partner
                    </h4>
                  </div>
                  <div class="col-md-12 text-center">
                    <p
                      class="mt-1"
                      v-for="(item, index) in userAsset.assets"
                      :key="index"
                    >
                      {{ item }}
                    </p>
                  </div>
                </div>
              </div>
              <ag-loading v-if="userAssetLoading" />
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="border-0 ag-button ag-button_radius pr-4 pl-4 ag-button_primary float-inline-end"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ag-user-modal
      :selected-user="selectedUser"
      @formsuccess="userFormSuccess"
    ></ag-user-modal>
  </div>
</template>

<script>
/* eslint-disable */
import { computed, defineComponent, ref } from "vue";
import AgCard from "@/components/ag-card/index.vue";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { useStore } from "@/store";
import axiosIdentity from "@/store/axiosIdentity";
import api from "@/api/index";
const store = useStore();
import { notify } from "@kyvg/vue3-notification";
import Users from "@/helpers/pages/Users";
import generator from "generate-password";
import AgLoading from "@/components/ag-loading/index.vue";
import apiIdentity from "@/store/axiosIdentity";
import { Roles } from "@/helpers/enums/Roles";
import AgUserModal from "@/components/ag-user-modal/index.vue";

export default defineComponent({
  name: "Users",
  components: { AgCard, AgLoading, AgUserModal },
  setup() {
    let filter = ref({
      page: 1,
      limit: 5,
      firstName: "",
      lastName: "",
      sortColumn: "createdAt",
      sortDir: "asc",
      loginId: "",
    });
    const module = ref(Users);

    let action = "add";
    const submitFunction = function (e) {
      if (action === "add") {
        console.log("add");
      } else {
        console.log("edit");
      }
      e.preventDefault();
    };
    const deleteFunction = function (id) {
      this.$swal
        .fire({
          title: "Are You Sure?",
          icon: "warning",
          text: "You are about to delete the selected item!",
          showCancelButton: true,
          confirmButtonText: "Delete",
        })
        .then((result) => {
          if (result.isConfirmed) {
            axiosIdentity
              .delete("Delete/" + id)
              .then((res) => {
                if (
                  Number(res.data.statusCode) == 200 ||
                  Number(res.data.status) == 200
                ) {
                  notify({
                    title: "Deleted!",
                    type: "success",
                    text: "The user has been deleted.",
                    duration: 5000,
                    closeOnClick: true
                  });
                } else {
                  this.$swal.fire("Error", res.data.Errors, "error");
                }
              })
              .catch((e) => {
                this.$swal.fire("Error", JSON.stringify(e.Message), "error");
              })
              .finally(() => {
                const options = this.module.component.options;
                options.page = 1;
                store.dispatch(GeneralActionTypes.GET_USERS, {
                  options: options,
                  filters: {},
                });
              });
          }
        });
    };
    const editFunction = async function (id) {
      action = "edit";
      const res = await api.users.getById(id);
      const user = res.data.entityData;
      this.selectedUser = user;
    };
    const reloadFunction = function (id) {
      console.log("reloadFunction");
    };

    const getList = (
      filters = filter.value,
      options = module.value.component.options
    ) => {
      const body = { filters, options };
      console.log(body);
      store.dispatch(GeneralActionTypes.GET_USERS, body);
    };

    const searchWithFilters = (param) => {
      console.log(module.value.filter.filters);
      filter.value.firstName =
        module.value.filter.filters.filter((x) => x.param == "firstName")[0]
          .vmodel || "";
      filter.value.lastName =
        module.value.filter.filters.filter((x) => x.param == "lastName")[0]
          .vmodel || "";
      filter.value.loginId =
        module.value.filter.filters.filter((x) => x.param == "loginId")[0]
          .vmodel || "";

      const filters = filter.value;
      const options = module.value.component.options;
      module.value.readyToUseFilters = filters;

      getList(filters, options);
    };

    const resetFilters = () => {
      module.value.filter.filters.forEach((item) => {
        item.vmodel = null;
      });

      searchWithFilters(true);
      let query = Object.assign({}, router.currentRoute.value.query);
      delete query.searchResults;
      router.replace({ query });
    };
    return {
      searchWithFilters,
      resetFilters,
      getList,
      deleteFunction,
      editFunction,
      reloadFunction,
      submitFunction,
    };
  },
  data() {
    return {
      module: Users,
      currentUsers: [],
      passResult: "",
      passLoading: false,
      resetPassStep: 1,
      selectedUser: null,
      value: [],
      Roles: Roles,
      userAssetLoading: false,
      userAsset: null,
    };
  },
  computed: {
    users() {
      return store.state.general.users;
    },
  },
  watch: {
    users() {
      if (!this.objectIfEquals(this.users, this.currentUsers)) {
        // this.getList();
      }
    },
  },
  mounted() {
    const filters = this.filter;
    const options = this.module?.component?.options;
    this.getList(filters, options);
  },
  methods: {
    userFormSuccess() {
      const filters = this.filter;
      const options = this.module?.component?.options;
      this.getList(filters, options);
    },
    resetPassFunction(data) {
      this.resetPassStep = 1;
      this.selectedUser = data;
    },
    async assignedResourcesFunction(data) {
      this.userAssetLoading = true;
      this.userAsset = data;
      this.userAsset.assets = [];

      const user = await api.users.getUserAuthorizedEntities(data.id);

      if (data.role === Roles.SiteAdmin) {
        for (let index = 0; index < data.siteCount; index++) {
          const element = user.data.entityData.sites[index];
          const res = await api.sites.getById(element.replaceAll("_", "-"));
          this.userAsset.assets.push(res.data.entityData.name);
        }
      }
      if (data.role === Roles.GroupAdmin) {
        for (let index = 0; index < data.groupCount; index++) {
          const element = user.data.entityData.groups[index];
          const res = await api.groups.getById(element.replaceAll("_", "-"));
          this.userAsset.assets.push(res.data.entityData.name);
        }
      }
      if (data.role === Roles.CompanyAdmin) {
        for (let index = 0; index < data.companyCount; index++) {
          const res = await api.companies.getByGuid(user.data.entityData.companies[index]);
          this.userAsset.assets.push(res.data.entityData.companyName);
        }
      }
      if (data.role === Roles.PartnerAdmin) {
        const res = await api.partners.getById(user.data.entityData.partnerId);
        this.userAsset.assets.push(res.data.entityData.name);
      }
      this.userAssetLoading = false;
    },
    resetPassSubmit() {
      const vm = this;
      vm.passLoading = true;
      const password = generator.generate({
        length: 10,
        numbers: true,
        strict: true,
        symbols: true,
      });
      apiIdentity
        .post("ResetPasswordWithAdmin", {
          userId: this.selectedUser.id,
          newPassword: password,
        })
        .then((res) => {
          vm.passLoading = false;
          vm.passResult = password;
          vm.resetPassStep = 2;
        })
        .catch((e) => {
          vm.passLoading = false;
          if (e && e.errors) {
            const errors = e.errors.map((f) => "<li>" + f + "</li>");
            notify({
              title: "An Error Occurred..",
              type: "error",
              text: "<p>" + e.message + "</p>" + "<ul>" + errors + "</ul>",
              duration: 8000,
              closeOnClick: true
            });
          }
        })
        .finally(() => {
          //location.reload();
        });
    },
    async copy() {
      try {
        await navigator.clipboard.writeText(this.passResult);
        notify({
          title: "Copied",
          type: "success",
          duration: 3000,
          closeOnClick: true
        });
      } catch ($e) {
        notify({
          title: "Cannot copy",
          type: "error",
          duration: 3000,
          closeOnClick: true
        });
      }
    },

    objectIfEquals(x, y) {
      if (x === y) return true;
      if (!(x instanceof Object) || !(y instanceof Object)) return false;
      if (x.constructor !== y.constructor) return false;
      for (var p in x) {
        if (!x.hasOwnProperty(p)) continue;
        if (!y.hasOwnProperty(p)) return false;
        if (x[p] === y[p]) continue;
        if (typeof x[p] !== "object") return false;
        if (!this.objectIfEquals(x[p], y[p])) return false;
      }

      for (p in y)
        if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) return false;

      return true;
    },
  },
});
</script>

<style>
.ag-page_users #ag-table .ag-icon {
  font-size: 1.1em !important;
}
</style>